import pick from 'lodash/fp/pick';
import {connect} from 'react-redux';
import {getStatus, getResources} from 'redux-resource';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import mapProps from 'recompose/mapProps';
import withLoadingIndicator from '../../../common/with-loading-indicator/index';
import {readFiles} from '../../../../redux/actions/files';
import Tiles from './tiles';

function mapStateToProps(state, props) {
	const listName = `cat-${props.collectionId}`;
	const status = getStatus(state, `files.requests.${listName}.status`);
	const items = getResources(state.files, listName);

	return {
		status,
		language: state.language,
		items
	};
}

function mapDispatchToProps(dispatch, {collectionId}) {
	return {
		readList: () => {
			dispatch(readFiles(collectionId));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.readList();
		}
	}),
	withLoadingIndicator,
	mapProps(pick([
		'items',
		'handleOpenFile'
	]))
);

export default enhance(Tiles);



// WEBPACK FOOTER //
// ./src/client/components/main/files/tiles/index.js